import React from 'react';
import { useWizard } from '../../contexts/WizardContext';

const CloutWizardStep1: React.FC = () => {
  const { wizardData, updateStepData, nextStep, previousStep, isLoading } = useWizard();

  const handleSubmit = async () => {
    if (wizardData.name && wizardData.email) {
      await updateStepData(wizardData);
      nextStep();
    }
  };

  return (
    <div className="max-w-3xl mx-auto">
      <h2 className="font-['Ovo',_serif] text-[24px] sm:text-[28px] lg:text-[32px] text-[#1f1f1f] mb-6 sm:mb-8">Basic Information</h2>

      <div className="space-y-4 sm:space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block mb-2 font-['Open_Sans'] text-sm font-semibold text-[#1f1f1f]">
              Full Name *
            </label>
            <input
              type="text"
              value={wizardData.name || ''}
              onChange={(e) => updateStepData({ name: e.target.value })}
              className="w-full px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
              placeholder="Enter your full name"
            />
          </div>

          <div>
            <label className="block mb-2 font-['Open_Sans'] text-sm font-semibold text-[#1f1f1f]">
              Email *
            </label>
            <input
              type="email"
              value={wizardData.email || ''}
              onChange={(e) => updateStepData({ email: e.target.value })}
              className="w-full px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
              placeholder="Enter your email"
            />
          </div>
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row justify-between gap-3 sm:gap-0">
        <button
          onClick={previousStep}
          className="order-2 sm:order-1 px-6 sm:px-8 py-3 min-h-[44px] border border-[#1f1f1f] text-[#1f1f1f] font-['Ovo',_serif] text-[16px] sm:text-[18px] uppercase hover:bg-[#f5f5f5] transition-colors"
        >
          Back
        </button>
        <button
          onClick={handleSubmit}
          disabled={isLoading || !wizardData.name || !wizardData.email}
          className="order-1 sm:order-2 px-6 sm:px-8 py-3 min-h-[44px] bg-[#1f1f1f] text-white font-['Ovo',_serif] text-[16px] sm:text-[18px] uppercase hover:bg-[#2f2f2f] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Saving...' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default CloutWizardStep1;
